import type { PropsWithChildren } from "react";

import { useMutation } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { twJoin } from "tailwind-merge";

import { Button } from "./Button";

export function CopyButton({ value, children }: PropsWithChildren<{ value: string }>) {
  const { t } = useTranslation();
  const copy = useMutation({
    mutationFn: async () => {
      try {
        await navigator.clipboard.writeText(value);
      } catch (error) {
        console.error(error);
      }
    },
    onSuccess: () => {
      setTimeout(() => copy.reset(), 1200);
    },
  });

  return (
    <Button type="button" onClick={() => copy.mutate()}>
      <div className={twJoin("flex flex-row items-center gap-2", copy.isSuccess && "invisible")}>{children}</div>
      <div className={twJoin("absolute inset-0 flex items-center justify-center", !copy.isSuccess && "hidden")}>
        {copy.isSuccess && t("copied")}
      </div>
    </Button>
  );
}
